<style scoped>
.d-text {
  font-size: 1.25rem;
  vertical-align: middle;
  color: black !important;
}
.mini-text {
  font-size: 0.9rem;
  vertical-align: middle;
  color: black !important;
  cursor: pointer;
}
.sub-th {
  text-align: center !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
  font-size: 10px !important;
  white-space: nowrap;
}

.th-ellipsis {
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
}
.n-ellipsis {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
}
.th-ellipsis:hover {
  text-overflow: clip;
  white-space: normal;
  word-break: break-all;
  width: 100%;
}
.v-data-table-header-mobile {
  display: none !important;
}

.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  background-color: white;
}

.first-col {
  width: 75px;
  left: 0px;
  text-align: center !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
}
</style>

<template>
  <div>
    <div class="mt-n8 mb-3 ml-6" style="font-size: 1.35rem" color="blue">
      รายงานสรุปผลกิจกรรม
      <v-divider class="mt-1"></v-divider>
    </div>
    <div class="mx-5">
      <v-row>
        <v-col cols="12" sm="12" lg="3">
          <v-card elevation="3">
            <v-card-text style="text-align: center">
              <div class="d-text my-2">คะแนนเฉลี่ย</div>
              <div class="d-text my-2">{{ avg_score | delimeter }} / 637</div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" lg="2">
          <v-row>
            <v-col cols="12" sm="12" lg="12" class="mb-n4">
              <v-card elevation="3">
                <v-card-text style="text-align: center" class="pa-3">
                  <span class="d-text">ผ่าน {{ pass | delimeter }} คน</span>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" lg="12">
              <v-card elevation="3">
                <v-card-text style="text-align: center" class="pa-3">
                  <span class="d-text"
                    >ไม่ผ่าน {{ failed | delimeter }} คน</span
                  >
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" lg="3">
          <v-card elevation="3">
            <v-card-text style="text-align: center">
              <div class="d-text my-2">น้ำหนักลดลง</div>
              <div class="d-text my-2">{{lossWeight}} คน</div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" lg="3">
          <v-card elevation="3">
            <v-card-text style="text-align: center">
              <div class="d-text my-2">รอบเอวลดลง</div>
              <div class="d-text my-2">{{lossWaist}} คน</div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" lg="1">
          <v-row>
            <v-col cols="12" sm="12" lg="12" class="mb-n4">
              <v-card elevation="3">
                <v-card-text style="text-align: center">
                  <div class="mini-text" @click="export_xls()">
                    ดาวน์โหลด
                    <v-icon class="mt-2" large>mdi-download</v-icon>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" lg="3" class="mb-n3 mt-n6">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="ค้นหาชื่อ / หน่วยบริการ"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" lg="2" class="mb-n10 mt-n4">
          <v-autocomplete
            :items="ss_data"
            solo
            v-model="ss"
            dense
            item-text="NAME"
            item-value="ID"
            @change="change_ss()"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="12" lg="3" class="mb-n10 mt-n4">
          <v-select
            :items="[
              'ทั้งหมด',
              'โครงการ 70 วันมหัศจรรย์ของฉัน ชีซั่น 9 (1 ก.ย. - 9 พ.ย. 66)',
              'โครงการ 70 วันมหัศจรรย์ของฉัน ชีซั่น 8 (1 มิ.ย. - 10 ส.ค. 66)',
              'โครงการ 70 วันมหัศจรรย์ของฉัน ชีซั่น 7 (1 มี.ค. - 10 พ.ค. 66)',
              'โครงการ 70 วันมหัศจรรย์ของฉัน ชีซั่น 4 (14 ก.พ. - 24 เม.ย 65)',
              'โครงการ 70 วันมหัศจรรย์ของฉัน ชีซั่น 5 (25 เม.ย - 3 ก.ค. 65)',
              'โครงการ 70 วันมหัศจรรย์ของฉัน ชีซั่น 6 (4 ก.ค. - 11 ก.ย. 65)',
              'โครงการ เกษียณสู้ต่อ',
              'โครงการ พก.สนับสนุนคนพิการ นำร่องภารกิจสุขภาพดี',
              'โครงการ Inclusive Workplace (IW)',
              'โครงการ : 70 วันเราทำได้ (เฉพาะเจ้าหน้าที่มูลนิธินวัตกรรมทางสังคม)',
              'รอบพิเศษ สำหรับคนไม่ผ่านปี 65',
            ]"
            solo
            v-model="from_project"
            dense
            placeholder="ประเภทโครงการ"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="12" lg="1" class="mb-n10 mt-n4">
          <v-btn
            style="width: 100%"
            dark
            color="#0089D6"
            @click="click_search()"
          >
            <v-icon left>mdi-magnify</v-icon>ค้นหา
          </v-btn>
        </v-col>
        <v-col cols="12" style="text-align: -webkit-right">
          <v-data-table
            dense
            :headers="headers"
            :items="tbl_data"
            class="elevation-1"
            hide-default-header
            :loading="tbl_load"
            :items-per-page="15"
            loading-text="กำลังเรียกข้อมูล..."
            :search="search"
          >
            <template v-slot:header="{ props: { headers } }">
              <thead v-if="ss >= 10">
                <tr>
                  <th class="n-ellipsis" rowspan="3">
                    {{ headers[0].text }}
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    {{ headers[1].text }}
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    {{ headers[2].text }}
                  </th>
                  <th class="sticky-col first-col" rowspan="3">
                    {{ headers[3].text }}
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    {{ headers[4].text }}
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    {{ headers[5].text }}
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    {{ headers[6].text }}
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    หน่วยงาน
                    {{ headers[7].text }}
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    ความพิการ
                    {{ headers[8].text }}
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    น้ำหนัก {{ headers[9].text }}<br />
                    (ก่อนทำ)
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    {{ headers[10].text }}<br />
                    (ก่อนทำ)
                  </th>
                </tr>
                <tr>
                  <th class="n-ellipsis" colspan="7">
                    {{ headers[11].text }}
                  </th>
                  <th class="n-ellipsis" colspan="7">
                    {{ headers[12].text }}
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    {{ headers[13].text }}
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    {{ headers[14].text }}
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    {{ headers[15].text }}<br />
                    (หลังทำ)
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    {{ headers[16].text }}<br />
                    (หลังทำ)
                  </th>
                </tr>
                <tr>
                  <th class="sub-th">ออกกำลังกาย</th>
                  <th class="sub-th">ลดหวาน</th>
                  <th class="sub-th">ลดเค็ม</th>
                  <th class="sub-th">ลดมัน</th>
                  <th class="sub-th">ทานผักผลไม้</th>
                  <th class="sub-th">ดื่มน้ำ</th>
                  <th class="sub-th">ลดความเครียด</th>
                  <th class="sub-th">ออกกำลังกาย</th>
                  <th class="sub-th">ลดหวาน</th>
                  <th class="sub-th">ลดเค็ม</th>
                  <th class="sub-th">ลดมัน</th>
                  <th class="sub-th">ทานผักผลไม้</th>
                  <th class="sub-th">ดื่มน้ำ</th>
                  <th class="sub-th">ลดความเครียด</th>
                </tr>
              </thead>

              <thead v-else>
                <tr>
                  <th class="n-ellipsis" rowspan="3">
                    {{ headers[0].text }}
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    {{ headers[1].text }}
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    {{ headers[2].text }}
                  </th>
                  <th class="sticky-col first-col" rowspan="3">
                    {{ headers[3].text }}
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    {{ headers[4].text }}
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    {{ headers[5].text }}
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    {{ headers[6].text }}
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    หน่วยงาน
                    {{ headers[7].text }}
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    ความพิการ
                    {{ headers[8].text }}
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    น้ำหนัก {{ headers[9].text }}<br />
                    (ก่อนทำ)
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    {{ headers[10].text }}<br />
                    (ก่อนทำ)
                  </th>
                </tr>
                <tr>
                  <th class="n-ellipsis" colspan="4">
                    {{ headers[11].text }}
                  </th>
                  <th class="n-ellipsis" colspan="4">
                    {{ headers[12].text }}
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    {{ headers[13].text }}
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    {{ headers[14].text }}
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    {{ headers[15].text }}<br />
                    (หลังทำ)
                  </th>
                  <th class="n-ellipsis" rowspan="3">
                    {{ headers[16].text }}<br />
                    (หลังทำ)
                  </th>
                </tr>
                <tr>
                  <th class="sub-th">ออกกำลังกาย</th>
                  <th class="sub-th">กินผัก</th>
                  <th class="sub-th">กินหวาน</th>
                  <th class="sub-th">ดื่มน้ำ</th>
                  <th class="sub-th">ออกกำลังกาย</th>
                  <th class="sub-th">กินผัก</th>
                  <th class="sub-th">กินหวาน</th>
                  <th class="sub-th">ดื่มน้ำ</th>
                </tr>
              </thead>
            </template>
            <template v-slot:item="{ item, index }">
              <tr v-if="ss >= 10">
                <td class="n-ellipsis">{{ index + 1 }}</td>
                <td class="th-ellipsis">{{ item.P_TYPE }}</td>
                <td class="th-ellipsis">{{ item.CID }}</td>
                <td
                  class="sticky-col first-col th-ellipsis"
                  style="text-align: left !important"
                >
                  {{ item.FULLNAME }}
                </td>
                <td class="th-ellipsis">{{ item.BIRTHDATE | calAage }}</td>
                <td class="th-ellipsis">{{ item.FROM_PROJECT }}</td>
                <td class="th-ellipsis">{{ item.PROVINCE }}</td>
                <td class="th-ellipsis">{{ item.ORGANIZATION }}</td>
                <td class="th-ellipsis">{{ item.HANDI_TYPE }}</td>
                <td class="n-ellipsis">{{ item.START_WEIGHT }}</td>
                <td class="n-ellipsis">{{ item.START_WAIST }}</td>
                <td class="n-ellipsis">{{ item.ACTIVITY1 }}</td>
                <td class="n-ellipsis">{{ item.ACTIVITY2 }}</td>
                <td class="n-ellipsis">{{ item.ACTIVITY3 }}</td>
                <td class="n-ellipsis">{{ item.ACTIVITY4 }}</td>
                <td class="n-ellipsis">{{ item.ACTIVITY5 }}</td>
                <td class="n-ellipsis">{{ item.ACTIVITY6 }}</td>
                <td class="n-ellipsis">{{ item.ACTIVITY7 }}</td>
                <td class="n-ellipsis">{{ item.AVG_ACT1 }}</td>
                <td class="n-ellipsis">{{ item.AVG_ACT2 }}</td>
                <td class="n-ellipsis">{{ item.AVG_ACT3 }}</td>
                <td class="n-ellipsis">{{ item.AVG_ACT4 }}</td>
                <td class="n-ellipsis">{{ item.AVG_ACT5 }}</td>
                <td class="n-ellipsis">{{ item.AVG_ACT6 }}</td>
                <td class="n-ellipsis">{{ item.AVG_ACT7 }}</td>
                <td class="n-ellipsis">{{ item.TOTAL_SCORE }}</td>
                <td
                  class="n-ellipsis"
                  :style="
                    evaluate_score(item.TOTAL_SCORE) == 'ผ่าน'
                      ? 'color:green !important'
                      : 'color:red !important'
                  "
                >
                  {{ evaluate_score(item.TOTAL_SCORE) }}
                </td>
                <td class="n-ellipsis">{{ item.END_WEIGHT }}</td>
                <td class="n-ellipsis">{{ item.END_WAIST }}</td>
              </tr>

              <tr v-else>
                <td class="n-ellipsis">{{ index + 1 }}</td>
                <td class="th-ellipsis">{{ item.P_TYPE }}</td>
                <td class="th-ellipsis">{{ item.CID }}</td>
                <td
                  class="sticky-col first-col th-ellipsis"
                  style="text-align: left !important"
                >
                  {{ item.FULLNAME }}
                </td>
                <td class="th-ellipsis">{{ item.BIRTHDATE | calAage }}</td>
                <td class="th-ellipsis">{{ item.FROM_PROJECT }}</td>
                <td class="th-ellipsis">{{ item.PROVINCE }}</td>
                <td class="th-ellipsis">{{ item.ORGANIZATION }}</td>
                <td class="th-ellipsis">{{ item.HANDI_TYPE }}</td>
                <td class="n-ellipsis">{{ item.START_WEIGHT }}</td>
                <td class="n-ellipsis">{{ item.START_WAIST }}</td>
                <td class="n-ellipsis">{{ item.ACTIVITY1 }}</td>
                <td class="n-ellipsis">{{ item.ACTIVITY2 }}</td>
                <td class="n-ellipsis">{{ item.ACTIVITY3 }}</td>
                <td class="n-ellipsis">{{ item.ACTIVITY4 }}</td>
                <td class="n-ellipsis">{{ item.AVG_ACT1 }}</td>
                <td class="n-ellipsis">{{ item.AVG_ACT2 }}</td>
                <td class="n-ellipsis">{{ item.AVG_ACT3 }}</td>
                <td class="n-ellipsis">{{ item.AVG_ACT4 }}</td>
                <td class="n-ellipsis">{{ item.TOTAL_SCORE }}</td>
                <td
                  class="n-ellipsis"
                  :style="
                    evaluate_score(item.TOTAL_SCORE) == 'ผ่าน'
                      ? 'color:green !important'
                      : 'color:red !important'
                  "
                >
                  {{ evaluate_score(item.TOTAL_SCORE) }}
                </td>
                <td class="n-ellipsis">{{ item.END_WEIGHT }}</td>
                <td class="n-ellipsis">{{ item.END_WAIST }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import XLSX from "xlsx";
export default {
  name: "Summary",
  components: {},
  data() {
    return {
      tbl_data: [],
      search: "",
      from_project: "ทั้งหมด",
      ss: null,
      tbl_load: true,
      ss_data: [],
      avg_score: 0,
      pass: 0,
      failed: 0,
      headers: [
        {
          text: "ลำดับ",
          align: "start",
          sortable: false,
          value: "INDEX",
        },
        { text: "ประเภท", value: "P_TYPE" },
        { text: "เลขบัตรประชาชน", value: "CID" },
        { text: "ชื่อ - สกุล", value: "FULLNAME", width: "250px" },
        { text: "อายุ", value: "BIRTHDATE" },
        { text: "ประเภทโครงการ", value: "FROM_PROJECT" },
        { text: "จังหวัด", value: "PROVINCE" },
        { text: "หน่วยงาน", value: "ORGANIZATION" },
        { text: "ความพิการ", value: "HANDI_TYPE" },
        { text: "น้ำหนัก", value: "START_WEIGHT" },
        { text: "รอบเอว", value: "START_WAIST" },
        { text: "ก่อนร่วมกิจกรรม", value: "" },
        { text: "กิจกรรมเฉลี่ย 10 week", value: "" },
        { text: "คะแนน", value: "TOTAL_SCORE" },
        { text: "ผล", value: "RESULT" },
        { text: "น้ำหนัก", value: "END_WEIGHT" },
        { text: "รอบเอว", value: "END_WAIST" },
      ],
    };
  },
  filters: {
    calAage(birthDate) {
      birthDate = new Date(birthDate);
      var otherDate = new Date();
      var years = otherDate.getFullYear() - birthDate.getFullYear();
      if (
        otherDate.getMonth() < birthDate.getMonth() ||
        (otherDate.getMonth() == birthDate.getMonth() &&
          otherDate.getDate() < birthDate.getDate())
      ) {
        years--;
      }

      return years;
    },

    delimeter(data) {
      if (!isNaN(parseFloat(data))) {
        let y = parseFloat(data).toFixed(0);
        let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return x;
      } else {
        return 0;
      }
    },

    formatDate(data) {
      return moment(data)
        .add("y", 543)
        .format("DD/MM/YYYY");
    },
  },
  created() {
    this.initialApi();
  },

  computed: {
    lossWeight(){
      return this.tbl_data.filter(person => person.END_WEIGHT !== undefined && person.END_WEIGHT && person.START_WEIGHT > person.END_WEIGHT).length;
    },
    lossWaist(){
      return this.tbl_data.filter(person => person.END_WAIST !== undefined && person.END_WAIST && person.START_WAIST > person.END_WAIST).length;
    }
  },
  methods: {
    initialApi() {
      this.api_ss_data();
    },
    click_search() {
      this.api_table_data();
      this.api_evaluate_score();
      this.api_avg_score();
    },
    api_ss_data() {
      this.$token_api
        .get("/get-season-data")
        .then((res) => {
          const result = res.data.data;
          if (result.length > 0) {
            this.ss_data = result;
            this.get_current_season();
          }
        })
        .catch((e) => {});
    },
    get_current_season() {
      this.$token_api
        .get("/get-lastest-season")
        .then((res) => {
          const result2 = res.data.data;
          this.ss = result2[0].ID || 4;

          this.api_table_data();
          this.api_evaluate_score();
          this.api_avg_score();
        })
        .catch((e) => {
          console.log(e);
        });
    },
    change_ss() {},
    m_calAge(birthDate) {
      birthDate = new Date(birthDate);
      var otherDate = new Date();

      var years = otherDate.getFullYear() - birthDate.getFullYear();

      if (
        otherDate.getMonth() < birthDate.getMonth() ||
        (otherDate.getMonth() == birthDate.getMonth() &&
          otherDate.getDate() < birthDate.getDate())
      ) {
        years--;
      }

      return years;
    },
    evaluate_score(score) {
      if (this.ss >= 10) {
        if (score >= 364) {
          return "ผ่าน";
        } else {
          return "ไม่ผ่าน";
        }
      } else {
        if (score >= 160) {
          return "ผ่าน";
        } else {
          return "ไม่ผ่าน";
        }
      }
    },

    api_avg_score() {
      this.$token_api
        .get(`/avg-score/${this.ss}/${this.from_project}`)
        .then((res) => {
          const result = res.data.data;
          if (result.length > 0) {
            this.avg_score = result[0].AVG_SCORE;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    api_evaluate_score() {
      this.pass = 0;
      this.failed = 0;
      this.$token_api
        .get(`/evaluate-score/${this.ss}/${this.from_project}`)
        .then((res) => {
          const result = res.data.data;
          if (result.length > 0) {
            for (let index = 0; index < result.length; index++) {
              if (result[index].RESULT == "ผ่าน") {
                this.pass = result[index].TOTAL_RESULT;
              } else {
                this.failed = result[index].TOTAL_RESULT;
              }
            }
          }
        })
        .catch((err) => {});
    },

    api_table_data() {
      this.tbl_load = true;
      this.$token_api
        .get(`/summary-report/${this.ss}/${this.from_project}`)
        .then((res) => {
          const result = res.data.data;
          if (result.length > 0) {
            this.tbl_data = result;
            this.tbl_load = false;
            console.log(result)
          } else {
            this.tbl_load = false;
            this.tbl_data = [];
          }
        })
        .catch((err) => {
          this.tbl_load = false;
          this.tbl_data = [];
        });
    },
    export_xls() {
      // this.LOADER(true)
      let data = this.tbl_data;
      let xls_json = [];
      if (data.length > 0) {
        if (this.ss >= 10) {
          data.forEach((element, i) => {
            xls_json.push({
              ลำดับ: i + 1,
              เลขบัตรประชาชน: element.CID,
              ประเภท: element.P_TYPE,
              "ชื่อ - นามสกุล": element.FULLNAME,
              อายุ: this.m_calAge(element.BIRTHDATE),
              ประเภทโครงการ: element.FROM_PROJECT,
              จังหวัด: element.PROVINCE,
              หน่วยงาน: element.ORGANIZATION,
              ความพิการ: element.HANDI_TYPE,
              "น้ำหนัก (ก่อนทำ)": element.START_WEIGHT,
              "รอบเอว (ก่อนทำ)": element.START_WAIST,
              "ออกกกำลังกาย (ก่อนทำ)": element.ACTIVITY1,
              "ลดหวาน (ก่อนทำ)": element.ACTIVITY2,
              "ลดเค็ม (ก่อนทำ)": element.ACTIVITY3,
              "ลดมัน (ก่อนทำ)": element.ACTIVITY4,
              "ทานผักผลไม้ (ก่อนทำ)": element.ACTIVITY5,
              "ดื่มน้ำ (ก่อนทำ)": element.ACTIVITY6,
              "ลดความเครียด (ก่อนทำ)": element.ACTIVITY7,
             "ออกกกำลังกาย (หลังทำ)": element.AVG_ACT1,
              "ลดหวาน (หลังทำ)": element.AVG_ACT2,
              "ลดเค็ม (หลังทำ)": element.AVG_ACT3,
              "ลดมัน (หลังทำ)": element.AVG_ACT4,
              "ทานผักผลไม้ (หลังทำ)": element.AVG_ACT5,
              "ดื่มน้ำ (หลังทำ)": element.AVG_ACT6,
              "ลดความเครียด (หลังทำ)": element.AVG_ACT7,
              คะแนน: element.TOTAL_SCORE,
              ผล: this.evaluate_score(element.TOTAL_SCORE),
              "น้ำหนัก (หลังทำ)": element.END_WEIGHT,
              "รอบเอว (หลังทำ)": element.END_WAIST,
            });
          });
        } else {
          data.forEach((element, i) => {
            xls_json.push({
              ลำดับ: i + 1,
              เลขบัตรประชาชน: element.CID,
              ประเภท: element.P_TYPE,
              "ชื่อ - นามสกุล": element.FULLNAME,
              อายุ: this.m_calAge(element.BIRTHDATE),
              ประเภทโครงการ: element.FROM_PROJECT,
              จังหวัด: element.PROVINCE,
              หน่วยงาน: element.ORGANIZATION,
              ความพิการ: element.HANDI_TYPE,
              "น้ำหนัก (ก่อนทำ)": element.START_WEIGHT,
              "รอบเอว (ก่อนทำ)": element.START_WAIST,
              "กินหวาน (ก่อนทำ)": element.ACTIVITY1,
              "ออกกำลังกาย (ก่อนทำ)": element.ACTIVITY2,
              "กินผัก (ก่อนทำ)": element.ACTIVITY3,
              "ดื่มน้ำ (ก่อนทำ)": element.ACTIVITY4,
              "กินหวาน (หลังทำ)": element.AVG_ACT1,
              "ออกกำลังกาย (หลังทำ)": element.AVG_ACT2,
              "กินผัก (หลังทำ)": element.AVG_ACT3,
              "ดื่มน้ำ (หลังทำ)": element.AVG_ACT4,
              คะแนน: element.TOTAL_SCORE,
              ผล: this.evaluate_score(element.TOTAL_SCORE),
              "น้ำหนัก (หลังทำ)": element.END_WEIGHT,
              "รอบเอว (หลังทำ)": element.END_WAIST,
            });
          });
        }
        const dataWS = XLSX.utils.json_to_sheet(xls_json);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, dataWS);
        XLSX.writeFile(wb, `รายงานสรุปผลกิจกรรม.xlsx`);
        // this.LOADER(false)
      } else {
        // this.LOADER(false)
        this.$swal({
          title: "ไม่พบข้อมูล",
          icon: "warning",
          text: `กรุณาค้นหาข้อมูลใหม่อีกครั้ง`,
          timer: 2000,
        });
      }
    },
  },
};
</script>
